import type {Reminder} from '@/services/reminders/models'
import {
	AXD_CAT_PRODUCT,
	GAL_DOG_PRODUCT,
	SER_CAT_PRODUCT,
	SER_DOG_PRODUCT,
} from '@/utilities/constants'

export const groupReminders = (reminders: Reminder[]): Reminder[] => {
	const groupedMedicationsDictionary: Record<string, Reminder> = {}
	reminders.forEach((reminder) => {
		groupedMedicationsDictionary[
			`${reminder.pet?.id}-${reminder.marketingBrand?.id}`
		] = reminder
	})
	return Object.values(groupedMedicationsDictionary)
}

export const isProductSeresto = (productId: string): boolean =>
	productId === SER_DOG_PRODUCT || productId === SER_CAT_PRODUCT

export const isProductAdvantageXD = (productId: string): boolean =>
	productId === AXD_CAT_PRODUCT

export const isProductGalliprant = (productId: string): boolean =>
	productId === GAL_DOG_PRODUCT
